import { render, staticRenderFns } from "./ConfigFtp.vue?vue&type=template&id=29592104"
import script from "./ConfigFtp.vue?vue&type=script&lang=js"
export * from "./ConfigFtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports